// Saving a person's settings for all their devices (hub settings.go): the ones given change,
// the rest stay. The store takes the change at once (a list regroups as it's picked), then
// what the hub saved; a toast says when it couldn't, and the change is undone.

import { saveSettings } from '../api';
import { store, toast, type Settings } from '../store';

export async function updateSettings(patch: Partial<Settings>): Promise<boolean> {
  const before = store.get().me;
  if (!before) return false;
  store.set({ me: { ...before, settings: { ...before.settings, ...patch } } });
  const r = await saveSettings(patch);
  const cur = store.get().me;
  if (!r.ok) {
    toast({ title: 'Couldn’t save the setting', body: r.error, kind: 'error' });
    if (cur) store.set({ me: { ...cur, settings: before.settings } });
    return false;
  }
  if (cur) store.set({ me: { ...cur, settings: r.settings } });
  return true;
}
